import { create } from "zustand";

interface ModalState {
  isCampaignActivationModalOpen: boolean;
  openCampaignActivationModal: () => void;
  closeCampaignActivationModal: () => void;
}

export const useCampaignActivationModalStore = create<ModalState>((set) => ({
  isCampaignActivationModalOpen: false,
  openCampaignActivationModal: () =>
    set({ isCampaignActivationModalOpen: true }),
  closeCampaignActivationModal: () =>
    set({ isCampaignActivationModalOpen: false }),
}));
